import type { ButtonBannerProps } from "/types/partTypes/ButtonBanner";

import React from 'react';
import { Link } from '@hdir/ui/link';
import './button-banner.scss';


export function ButtonBanner(props: ButtonBannerProps): React.JSX.Element {
	const {
		title,
		text,
		image,
		buttons,
	} = props;

	return (
		<section className="w-full rounded-sm flex flex-col-reverse tablet:flex-row gap-y-md justify-start tablet:justify-between p-md tablet:p-xxl bg-surface-neutral-primary">
			<div className="flex flex-col gap-md tablet:gap-xl max-h-fit">
				<h2 className="font-bold text-xxl text-balance max-w-text text-neutral-inverted">{title}</h2>
				<p className="max-w-text text-neutral-inverted">{text}</p>
				<div className="flex flex-wrap gap-md">
					{buttons && (
						<>
							<Link
								href={buttons[0].link?.href}
								variant="button-primary"
								className="banner-button banner-button--primary"
								size="large"
							>
								{buttons[0].linkText}
							</Link>
							{
								buttons[1]
									? <Link
										href={buttons[1].link?.href}
										variant="button-secondary"
										className="banner-button banner-button--secondary"
										size="large"
									>
										{buttons[1].linkText}
									</Link>
									: null
							}
						</>
					)}
				</div>
			</div>
			<img className="h-20 tablet:h-[167px] w-auto mr-auto tablet:mr-0 aspect-square" src={image?.url} alt={image?.alt}/>
		</section>
	);
}
